import * as React from 'react';
import type { CartGroupOptionAdapterType } from '../../../../../Cart/CartItemOptionAdapter/CartItemOptionAdapter';
import CartItemOptionAdapter from '../../../../../Cart/CartItemOptionAdapter/CartItemOptionAdapter';
import ServiceSummaryDivider from '../../../../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import type { ServiceOptionItem } from '../../../../../ServiceSummary/types';
import { ALL_SEGMENTS_KEY } from '@shared/lib/flight';

interface Props {
	groups: CartGroupOptionAdapterType[];
	selectedIds?: string[];
	disabled?: boolean;
	onSelect?: (item: ServiceOptionItem) => void;
}

const ServiceProductsSummary: React.FC<Props> = ({ groups, selectedIds, disabled, onSelect }) => {
	if (!groups.length) {
		return null;
	}

	return (
		<ServiceSummaryDivider>
			{groups.map((group, index) => {
				const directionId = group.allSegments ? ALL_SEGMENTS_KEY : group.direction?.id;
				const travellerId = group.traveller?.id;
				const key = directionId && travellerId ? `${directionId}/${travellerId}` : index;

				return (
					<CartItemOptionAdapter
						key={key}
						option={group}
						selectedIds={selectedIds}
						disabled={disabled}
						onSelect={onSelect}
					/>
				);
			})}
		</ServiceSummaryDivider>
	);
};

export default ServiceProductsSummary;
